/* global Swiper */
/* global translations */

/**
 * A class for handling gallery popups with sliders
 *
 * @class
 */
class GalleryModal {

	/**
	 * Initializes the gallery modal
	 */
	constructor() {

		this.closeString = translations.close;
		this.gallerySelector = '.wp-block-gallery';
		this.galleryLink = '.wp-block-image a';
		this.popup = null; // Reference to the popup element
		this.swiperInstance = null; // Reference to Swiper instance
		this.initGallery();

	}

	/**
	 * Initializes gallery by adding click event listeners to images
	 *
	 * @return {void}
	 */
	initGallery() {

		document.querySelectorAll( `${this.gallerySelector} ${this.galleryLink}` ).forEach( ( link, index ) => {

			link.addEventListener( 'click', ( event ) => {

				event.preventDefault();
				this.openPopup( index );

			} );

		} );

	}

	/**
	 * Opens a popup and initializes the slider
	 *
	 * @param {number} clickedIndex - Index of the clicked image
	 * @return {void}
	 */
	openPopup( clickedIndex ) {

		// Get all full-size images from href attributes of links
		const fullImages = Array.from(
			document.querySelectorAll( `${this.gallerySelector} ${this.galleryLink}` )
		).map( ( link ) => link.getAttribute( 'href' ) );

		// Create popup structure with full-size images
		const modalHtml = `
            <div class="gallery-modal modal show" role="dialog" aria-modal="true">
                <div class="gallery-modal__overlay modal__overlay" tabindex="0"></div>
				<button class="gallery-modal__close modal__close" aria-label="${this.closeString}">&times;</button>
                <div class="gallery-modal__content modal__content">
                    <div class="swiper">
                        <div class="swiper-wrapper">
                            ${fullImages.map( ( href ) => `
								<div class="swiper-slide"><img src="${href}" alt="Gallery image"></div>
							` ).join( '' )}
                        </div>
                        <button class="wp-block-button swiper-button-prev btn--swipe btn--swipe-light btn--swipe-size-normal btn--swipe-dark btn--swipe-arrow-left">
                        	<span class="wp-block-button__link wp-element-button" aria-hidden="true"></span>
						</button>
                        <button class="wp-block-button swiper-button-next btn--swipe btn--swipe-light btn--swipe-size-normal btn--swipe-dark btn--swipe-arrow-right">
							<span class="wp-block-button__link wp-element-button" aria-hidden="true"></span>
						</button>
                    </div>
                </div>
            </div>
        `;

		// Append popup to body
		document.body.insertAdjacentHTML( 'beforeend', modalHtml );
		this.popup = document.querySelector( '.gallery-modal' );

		// Initialize Swiper
		this.swiperInstance = new Swiper( '.swiper', {
			initialSlide: clickedIndex,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );

		// Add event listeners for close button and overlay
		this.addEventListeners();

	}

	/**
	 * Adds event listeners for modal close and keyboard navigation
	 *
	 * @return {void}
	 */
	addEventListeners() {

		const closeButton = this.popup.querySelector( '.gallery-modal__close' );
		const overlay = this.popup.querySelector( '.gallery-modal__overlay' );

		// Close popup on button click or overlay click
		closeButton.addEventListener( 'click', () => this.closePopup() );
		overlay.addEventListener( 'click', () => this.closePopup() );

		// Handle keyboard events
		document.addEventListener( 'keydown', this.handleKeyPress.bind( this ) );

	}

	/**
	 * Handles keypress events for accessibility
	 *
	 * @param {KeyboardEvent} event - The keyboard event
	 * @return {void}
	 */
	handleKeyPress( event ) {

		if ( event.key === 'Escape' ) {

			this.closePopup();

		}
		if ( event.key === 'Enter' ) {

			const activeElement = this.popup?.ownerDocument.activeElement;
			if ( activeElement.classList.contains( 'swiper-button-next' ) ) {

				this.swiperInstance.slideNext();

			}
			if ( activeElement.classList.contains( 'swiper-button-prev' ) ) {

				this.swiperInstance.slidePrev();

			}
			if ( activeElement.classList.contains( 'gallery-modal__close' ) ) {

				this.closePopup();

			}

		}
		if ( event.key === 'ArrowRight' ) {

			// Move to the next slide
			this.swiperInstance.slideNext();

		}
		if ( event.key === 'ArrowLeft' ) {

			// Move to the previous slide
			this.swiperInstance.slidePrev();

		}

	}

	/**
	 * Closes the popup and destroys the Swiper instance
	 *
	 * @return {void}
	 */
	closePopup() {

		if ( this.swiperInstance ) {

			this.swiperInstance.destroy(); // Destroy Swiper instance
			this.swiperInstance = null;

		}
		if ( this.popup ) {

			this.popup.remove(); // Remove popup from DOM
			this.popup = null;

		}
		document.removeEventListener( 'keydown', this.handleKeyPress.bind( this ) ); // Remove keypress listener

	}

}

new GalleryModal();
